/**
 * #1411 (D367.19) — which grounds the new-look Grounds map shows.
 *
 * `default` is the player's own grounds (played; for a coach, the grounds they added) plus the grounds near the
 * device when a position is known. `played` is the own grounds alone, `near` the nearby set alone, `all` every
 * ground the page holds (today's directory behaviour). The map fits whatever this returns.
 */
export const GROUNDS_VIEWS = ["default", "played", "near", "all"];

export function viewRows({ view, rows, isOwn, nearById, searching = false }) {
  // A search answers from the whole directory, as it does on the shipped page; only a chip the reader chose narrows it.
  if (view === "all" || (view === "default" && searching)) return rows;
  const isNear = (g) => Boolean(nearById && nearById.has(g.ground_id));
  if (view === "played") return rows.filter(isOwn);
  if (view === "near" && nearById) return rows.filter(isNear);
  const picked = rows.filter((g) => isOwn(g) || isNear(g));
  // Nothing own and no position, or the played list not answered yet (or hung, #1499): an empty map would hide the
  // pins and keep the first fit's hold from ever arming, so the directory stands in until the own grounds arrive.
  if (picked.length === 0) return rows;
  return picked;
}

/** Which of the three chips (`played`, `near`, `all`) read as pressed. */
export function chipsPressed(view, positionKnown) {
  if (view === "default") return positionKnown ? ["played", "near"] : ["played"];
  return [view];
}

/** Near me's distances, kept on every view: nearby rows carry `_km` / `_distanceLabel` and come first, nearest first. */
export function withNearDistances(rows, nearById) {
  if (!nearById) return rows;
  const near = rows
    .filter((g) => nearById.has(g.ground_id))
    .map((g) => ({ ...g, _km: nearById.get(g.ground_id)._km, _distanceLabel: nearById.get(g.ground_id)._distanceLabel }))
    .sort((a, b) => a._km - b._km);
  return [...near, ...rows.filter((g) => !nearById.has(g.ground_id))];
}

/**
 * The saved list the map frames. A coach has no saved list; the grounds they added take its place, in the saved-row
 * shape, so the map frames them even when the directory answer for the first frame does not carry them.
 */
export function foldVenuesFor({ isCoach, added, savedVenues }) {
  if (!isCoach) return savedVenues;
  return added.map((g) => ({ ground_id: g.ground_id, name: g.name, city: g.city, country: g.country, latitude: g.latitude, longitude: g.longitude, place_type: g.placeType, archived_at: g.archivedAt }));
}
